import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './themes.css';
import { applyTheme } from './components/ThemeSwitcher';

// Appliquer le thème sauvegardé dès le chargement (avant le premier render)
applyTheme(localStorage.getItem('theme') || 'clair');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
